import { CustomColumn } from '../../types/customColumn';
import { DocumentSequenceSummary } from '../../types/document/DocumentSequenceTypes';

export const documentSequenceColumns: CustomColumn<DocumentSequenceSummary>[] = [
  {
    Header: 'Sucursal',
    accessor: 'branchName',
    customCell: ({ row }) => (
      <div className="text-sm font-medium text-black dark:text-white">
        {row.original.branchName}
      </div>
    ),
  },
  {
    Header: 'Tipo de Documento',
    accessor: 'documentTypeName',
    customCell: ({ row }) => (
      <div className="text-gray-700 dark:text-gray-300 text-sm">
        {row.original.documentTypeName}
      </div>
    ),
  },
  {
    Header: 'Prefijo',
    accessor: 'prefix',
    customCell: ({ row }) => (
      <span className="text-sm font-semibold text-primary">
        {row.original.prefix}
      </span>
    ),
  },
  {
    Header: 'Correlativo Actual',
    accessor: 'currentNumber',
    customCell: ({ row }) => (
      <span className="text-sm">{row.original.currentNumber}</span>
    ),
  },
];
